// extracted by mini-css-extract-plugin
export default {"addCreditsCard":"addCreditsCard_addCreditsCard__mEZPn","addCreditsCardTitle":"addCreditsCard_addCreditsCardTitle__xbylv"};